import { Modal as ModalModule, UI } from 'common';
import isNaN from 'lodash/isNaN';
import isNumber from 'lodash/isNumber';
import isString from 'lodash/isString';
import React from 'react';
import HistoryCommunication from '../utils/HistoryCommunication';

const { Spinner } = UI;
const { Modal, ModalContext, ModalButtonActionType } = ModalModule;

class CreateDHLeCModal extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			isLoading: false,
			manifests: [],
		};
	}

	/**
	 * Display message when no transactions are found.
	 */
	displayNoTransactionsFound = () => {
		const { modalId } = this.props;
		const { showMessage, closeModal } = this.context;

		showMessage({
			data: {
				title: 'No Transactions Found',
				description: `<p>There are no unmanifested transactions.</p>`,
				primaryButtonText: 'OK',
			},
			closeCallback: () => {
				closeModal(modalId);
			},
		});
	};

	/**
	 * Display error message.
	 * @param {object} error
	 * @returns error modal
	 */
	displayError = error => {
		const { modalId } = this.props;
		const { showError, closeModal } = this.context;

		return showError({
			data: {
				code:
					isNumber(error.errorCode) && !isNaN(error.errorCode)
						? error.errorCode
						: null,
				title: !isNumber(error.errorCode) ? 'Error' : null,
				description: `<p>${error.errorMessage}</p>`,
				primaryButtonText: 'OK',
				handleType: 'custom',
			},
			closeCallback: () => {
				closeModal(modalId);
			},
		});
	};

	/**
	 * Make necessary API calls to create manifest.
	 */
	createManifest = async () => {
		this.setState({ isLoading: true });

		const [domesticCountResponse, internationalCountResponse] =
			await Promise.all([
				HistoryCommunication.getManifestCountDHLeC('domestic'),
				HistoryCommunication.getManifestCountDHLeC('international'),
			]);

		const domesticCount = domesticCountResponse?.data?.count || 0;
		const internationalCount = internationalCountResponse?.data?.count || 0;
		const manifests = [];
		let createDomesticManifestResponse = null;
		let createInternationalManifestResponse = null;

		if (domesticCount === 0 && internationalCount === 0) {
			this.displayNoTransactionsFound();
			this.setState({ isLoading: false });
		} else {
			// if there are eligible prints, make api call to create manifest
			if (domesticCount > 0 && internationalCount > 0) {
				[createDomesticManifestResponse, createInternationalManifestResponse] =
					await Promise.all([
						HistoryCommunication.createManifestDHLeC('domestic'),
						HistoryCommunication.createManifestDHLeC('international'),
					]);
			} else if (domesticCount > 0) {
				createDomesticManifestResponse =
					await HistoryCommunication.createManifestDHLeC('domestic');
			} else if (internationalCount > 0) {
				createInternationalManifestResponse =
					await HistoryCommunication.createManifestDHLeC('international');
			}

			if (createDomesticManifestResponse) {
				if (HistoryCommunication.isSuccessful(createDomesticManifestResponse)) {
					manifests.push(createDomesticManifestResponse.data.labels);
				} else {
					const error = this.parseErrorResponse(createDomesticManifestResponse);
					this.displayError(error);
				}
			}

			if (createInternationalManifestResponse) {
				if (
					HistoryCommunication.isSuccessful(createInternationalManifestResponse)
				) {
					manifests.push(createDomesticManifestResponse.data.labels);
				} else {
					const error = this.parseErrorResponse(
						createInternationalManifestResponse
					);
					this.displayError(error);
				}
			}

			this.setState({
				isLoading: false,
				manifests,
			});
		}
	};

	parseErrorResponse = response => {
		const errorMessage = isString(response?.error?.errorMessage)
			? response.error.errorMessage
			: response.ErrorDescription;

		return {
			errorCode: response?.error?.errorCode,
			errorMessage,
		};
	};

	render() {
		const { modalId } = this.props;
		const { isLoading, manifests } = this.state;

		return (
			<>
				<Modal
					modalId={modalId}
					header="DHL eCommerce Manifest"
					className="dhlec create-dhlec-modal"
					primaryButton={{
						type: ModalButtonActionType.Ok,
						text: 'Print Manifest',
						onClick: this.createManifest,
					}}
					secondaryButton={{
						type: ModalButtonActionType.Cancel,
						text: 'Close',
					}}
				>
					<p>
						Any eligible domestic and international DHL eCommerce
						<br />
						transactions will be included in one or more manifests.
					</p>
					<p>Please note the following:</p>
					<ul>
						<li>Each shipment can only appear on one Manifest</li>
						<li>
							If you have more than 500 shipments, please repeat this
							<br />
							process until all shipments are manifested.
						</li>
					</ul>
					{isLoading && <Spinner msg="Loading DHL eCommerce Manifest..." />}
				</Modal>
				{manifests.length > 0 && (
					<Modal
						modalId={modalId}
						className="history-manifest manifest-pdf-modal"
						header="DHL eCommerce Manifest"
						hideFooter
					>
						<div>
							{manifests
								.flat()
								.map(obj => obj.href)
								.map((url, index) => (
									<iframe
										title="DHL eCommerce Manifest"
										key={index}
										src={url}
										width="100%"
										height="900"
									/>
								))}
						</div>
					</Modal>
				)}
			</>
		);
	}
}

CreateDHLeCModal.contextType = ModalContext;

export default CreateDHLeCModal;
